/* global google */
const gMap = document.querySelector('.mod-map__init');
const mapPins = document.querySelectorAll('.mod-map__pins-info');

function initialize(el, mapLat, mapLng, mapZoom) {
  const mapOptions = {
    zoom: Number(mapZoom),
    center: new google.maps.LatLng(Number(mapLat), Number(mapLng)),
  };

  const map = new google.maps.Map(el, mapOptions);
  const infoWindow = new google.maps.InfoWindow({ disableAutoPan: true });

  mapPins.forEach((mapPin) => {
    const pinLat = mapPin.getAttribute('data-markerlat');
    const pinLng = mapPin.getAttribute('data-markerlng');
    const popupContent = mapPin.getAttribute('data-popuptext');

    const marker = new google.maps.Marker({
      map,
      position: new google.maps.LatLng(pinLat, pinLng),
    });

    marker.addListener('click', () => {
      infoWindow.setContent(popupContent);
      infoWindow.open(map, marker);
    });
  });
}

if (gMap) {
  const mapLat = gMap.getAttribute('data-lat');
  const mapLng = gMap.getAttribute('data-lng');
  const mapZoom = gMap.getAttribute('data-zoom');

  initialize(gMap, mapLat, mapLng, mapZoom);
}
